import { render, staticRenderFns } from "./TestingOfAiSheathPage.vue?vue&type=template&id=56122fba&scoped=true&"
import script from "./TestingOfAiSheathPage.vue?vue&type=script&lang=js&"
export * from "./TestingOfAiSheathPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56122fba",
  null
  
)

export default component.exports